import { useMemo } from 'react';
import clsx from 'clsx';
import { CustomPortableText } from 'shared/studio/PortableText';
import { makePortableTextBlock } from '../utils';
import styles from '../../styles.module.scss';

export const FormattedTextBlock: React.FC<{
  className?: string;
  variant?: 'bodySmall';
  text: string;
}> = ({ className, text, variant = 'bodySmall' }) => {
  const textValue = useMemo(() => makePortableTextBlock(text), [text]);

  return <CustomPortableText className={clsx(className, styles[variant])} value={textValue} />;
};
